<template>
    <footer class="app-footer">
        <div class="container">
            <div class="footer-content">
                <div class="footer-section footer-contact">
                    <h3>联系方式</h3>
                    <ul class="contact-list">
                        <li class="address-item">
                            <el-icon>
                                <Location />
                            </el-icon>
                            郑州航空港经济综合实验区华夏大道与慈航路交汇处中原数字视听产业园一期11号楼2楼221室
                        </li>
                        <li>
                            <el-icon>
                                <Phone />
                            </el-icon>
                            400-9230-866
                        </li>
                        <li>
                            <el-icon>
                                <Phone />
                            </el-icon>
                            <a class="footer-site-link" href="tel:+8637155987845">0371-55987845</a>
                            <span>（+86 371 5598 7845）</span>
                        </li>
                        <li class="email-item">
                            <el-icon>
                                <Message />
                            </el-icon>
                            <span class="footer-emails">
                                <a class="footer-site-link" href="mailto:legal@mail.yunxuanwl.cn">法律业务：legal@mail.yunxuanwl.cn</a>
                                <a class="footer-site-link" href="mailto:business@mail.yunxuanwl.cn">商务合作：business@mail.yunxuanwl.cn</a>
                                <a class="footer-site-link" href="mailto:support@mail.yunxuanwl.cn">售后支持：support@mail.yunxuanwl.cn</a>
                            </span>
                        </li>
                        <li>
                            <el-icon>
                                <Link />
                            </el-icon>
                            <a href="https://yunxuanwl.cn" target="_blank" rel="noopener noreferrer"
                                class="footer-site-link">yunxuanwl.cn</a>
                        </li>
                    </ul>
                </div>

                <div class="footer-section footer-links">
                    <h3>快速链接</h3>
                    <ul class="quick-links">
                        <li v-for="item in quickLinks" :key="item.name">
                            <a v-if="item.external" :href="item.path" target="_blank" rel="noopener noreferrer">
                                {{ item.name }}
                            </a>
                            <router-link v-else :to="item.path">{{ item.name }}</router-link>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="footer-bottom">
                <p>版权所有 © 2018-2026 郑州云轩网络科技有限公司</p>
                <p class="filing-links">
                    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">
                        豫ICP备2024080543号-2
                    </a>
                    <span class="divider">|</span>
                    <a class="public-security-record" href="http://www.beian.gov.cn/" target="_blank" rel="noopener">
                        <img :src="publicSecurityRecordIcon" alt="" width="16" height="17" />
                        豫公网安备2024080543号
                    </a>
                    <span class="divider">|</span>
                    <router-link to="/about/telecom-license">
                        增值电信业务经营许可证：{{ telecomLicenseNumber }}
                    </router-link>
                </p>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import { Location, Phone, Message, Link } from '@element-plus/icons-vue'
import publicSecurityRecordIcon from '@/assets/icons/public-security-record.png'
import { telecomLicenseNumber } from '@/data/companyCredentials'

const quickLinks = [
    { name: '首页', path: '/' },
    { name: '业务范围', path: '/business' },
    { name: '企业服务', path: 'https://es.yunxuanwl.cn/zh-cn/', external: true },
    { name: '成功案例', path: '/success-cases' },
    { name: '合作伙伴', path: '/partners' },
    { name: '关于我们', path: '/about' },
    { name: '营业执照', path: '/about/business-license' },
    { name: '增值电信许可证', path: '/about/telecom-license' },
    { name: '联系我们', path: '/contact' }
]
</script>

<style scoped lang="scss">
.app-footer {
    margin-top: auto;
    background: #f5f5f5;
    padding: 60px 0 20px;
    color: #666;

    .footer-content {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 40px;
        margin-bottom: 40px;

        .footer-section {
            h3 {
                font-size: 18px;
                color: #333;
                margin-bottom: 20px;
                position: relative;
                padding-bottom: 10px;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 30px;
                    height: 2px;
                    background: var(--el-color-primary);
                }
            }

            p {
                line-height: 1.8;
                margin: 0;
            }

            .contact-list {
                list-style: none;
                padding: 0;
                margin: 0;
                display: flex;
                flex-direction: column;
                gap: 15px;

                li {
                    display: flex;
                    align-items: center;
                    gap: 8px;

                    .el-icon {
                        color: var(--el-color-primary);
                        flex-shrink: 0;
                    }

                    &.address-item {
                        white-space: nowrap;
                    }

                    &.email-item {
                        align-items: flex-start;

                        .el-icon {
                            margin-top: 3px;
                        }
                    }

                    .footer-emails {
                        display: flex;
                        flex-direction: column;
                        gap: 6px;
                    }

                    .footer-site-link {
                        color: #666;
                        text-decoration: none;
                        transition: color 0.3s;

                        &:hover {
                            color: var(--el-color-primary);
                        }
                    }
                }
            }

            .quick-links {
                list-style: none;
                padding: 0;
                margin: 0;
                display: flex;
                flex-direction: column;
                gap: 15px;

                a {
                    color: #666;
                    text-decoration: none;
                    transition: color 0.3s;

                    &:hover {
                        color: var(--el-color-primary);
                    }
                }
            }
        }

        .footer-contact {
            text-align: left;
        }

        .footer-links {
            text-align: right;

            h3::after {
                left: auto;
                right: 0;
            }

            .quick-links {
                align-items: flex-end;
            }
        }
    }

    .footer-bottom {
        border-top: 1px solid #e8e8e8;
        padding-top: 20px;
        text-align: center;

        p {
            margin: 5px 0;
            font-size: 14px;

            a {
                color: #666;
                text-decoration: none;
                transition: color 0.3s;

                &:hover {
                    color: var(--el-color-primary);
                }
            }
        }

        .filing-links {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            row-gap: 6px;

            .public-security-record {
                display: inline-flex;
                align-items: center;

                img {
                    flex-shrink: 0;
                    margin-right: 5px;
                    object-fit: contain;
                }
            }
        }

        .divider {
            margin: 0 10px;
            color: #e8e8e8;
        }

    }
}

@media (max-width: 768px) {
    .app-footer {
        .footer-content {
            flex-direction: column;
            gap: 30px;

            .footer-contact,
            .footer-links {
                text-align: left;
            }

            .footer-links {
                h3::after {
                    left: 0;
                    right: auto;
                }

                .quick-links {
                    align-items: flex-start;
                }
            }

            .footer-section .contact-list li.address-item {
                white-space: normal;
            }
        }
    }
}
</style>
